<template>
  <div class="page">
    <el-row :gutter="20" class="page-row">
      <!-- 左侧卡片区域 -->
      <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" class="left-col">
        <el-card 
          class="study-card" 
          style="background-color: #ffffff;"
          shadow="hover"
          :class="{ 'clickable-card': hasAppointment }"
          @click.native="handleCardClick(1)"
        >
          <div class="card-content">
            <img
              class="card-image"
              referrerpolicy="no-referrer"
              :src="shuatiImage"
              alt="刷题"
            />
            <div class="card-text">
              <div class="card-title">刷题</div>
              <div class="card-desc">2000题精选</div>
            </div>
          </div>
        </el-card>
        <el-card 
          class="exam-card" 
                    style="background-color: #ffffff;"
          shadow="hover"
          :class="{ 'clickable-card': hasAppointment }"
          @click.native="handleCardClick(2)"
        >
          <div class="card-content">
            <img
              class="card-image"
              referrerpolicy="no-referrer"
              :src="bishiImage"
              alt="笔试"
            />
            <div class="card-text">
              <div class="card-title">模拟笔试</div>
              <div class="card-desc">加油！祝您成功</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧预约考试区域 -->
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" class="right-col">
        <el-card class="appointment-card"           style="background-color: #ffffff;"
 shadow="hover">
          <div slot="header" class="card-header">
            <div class="header-title">预约考试</div>
            <div class="header-desc">预约考试后可开始刷题</div>
          </div>
          
          <el-form :model="appointmentForm" class="appointment-form">
            <div class="form-item">
              <span class="form-label">岗位</span>
              <el-select
                v-model="appointmentForm.position"
                placeholder="请选择岗位"
                class="form-select"
                size="medium"
                :disabled="hasAppointment"
              >
                <el-option
                  v-for="item in positionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="form-item">
              <span class="form-label">时间</span>
              <el-row :gutter="10" class="time-row">
                <el-col :span="14">
                  <el-date-picker
                    v-model="appointmentForm.date"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    size="medium"
                    class="form-date-picker"
                    :disabled="hasAppointment"
                    :picker-options="datePickerOptions"
                    @change="handleDateChange"
                  ></el-date-picker>
                </el-col>
                <el-col :span="10">
                  <el-time-picker
                    v-model="appointmentForm.time"
                    placeholder="选择时间"
                    format="HH:mm"
                    value-format="HH:mm"
                    size="medium"
                    class="form-time-picker"
                    :disabled="hasAppointment"
                    :picker-options="timePickerOptions"
                    @change="handleTimeChange"
                  ></el-time-picker>
                </el-col>
              </el-row>
            </div>

            <div class="form-item">
              <el-button
                type="primary"
                class="submit-button" 
                style="background-color: #3695F0;"
                size="medium"
                :loading="submitting"
                @click="handleButtonClick"
              >
                {{ buttonText }}
              </el-button>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <!-- 考试时间到了弹窗 -->
    <el-dialog
      :visible.sync="examTimeDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
      center
      class="exam-time-dialog"
    >
      <div class="exam-dialog-content">
        <h3 class="exam-dialog-title">开始考试</h3>
        <p class="exam-dialog-message">您预约的考试时间到了,不进入默认考试失败</p>
        <el-button
          type="primary"
          class="exam-start-button"
          @click="handleStartExam"
        >
          开始考试
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { applyExam, getApply, cancelApply } from '@/api/exam'
import request from '@/utils/request'

export default {
  name: 'LanhuDengluweiyuyue',
  data() {
    return {
      submitting: false,
      hasAppointment: false, // 是否有预约数据
      appointmentForm: {
        position: null,
        date: '',
        time: ''
      },
      positionOptions: [], // 岗位选项，从后台接口获取
      examTimeDialogVisible: false, // 考试时间到了弹窗显示状态
      examTimeCheckTimer: null // 检查考试时间的定时器
    }
  },
  computed: {
    // 刷题图片路径
    shuatiImage() {
      return this.hasAppointment 
        ? require('./assets/img/st2.png')
        : require('./assets/img/st1.png')
    },
    // 笔试图片路径
    bishiImage() {
      return this.hasAppointment 
        ? require('./assets/img/bs2.png')
        : require('./assets/img/bs1.png')
    },
    // 日期选择器配置
    datePickerOptions() {
      return {
        disabledDate: (time) => {
          // 禁用一天之后之前的日期（只能预约一天后的日期）
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const minDate = new Date(today)
          // 只允许选择明天（含）之后的日期
          minDate.setDate(minDate.getDate() + 1)
          return time.getTime() < minDate.getTime()
        }
      }
    },
    // 时间选择器配置
    timePickerOptions() {
      const selectedDate = this.appointmentForm.date
      const today = new Date()
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
      
      // 如果选择的是今天，需要限制时间必须大于当前时间
      if (selectedDate === todayStr) {
        const now = new Date()
        const currentHour = now.getHours()
        const currentMinute = now.getMinutes()
        
        return {
          disabledHours: () => {
            // 禁用当前小时之前的所有小时
            const hours = []
            for (let i = 0; i < currentHour; i++) {
              hours.push(i)
            }
            return hours
          },
          disabledMinutes: (selectedHour) => {
            // 只允许选择整点（0分）和半点（30分）
            const minutes = []
            for (let i = 0; i < 60; i++) {
              // 如果不是整点或半点，禁用
              if (i !== 0 && i !== 30) {
                minutes.push(i)
              }
            }
            
            // 如果选择的是当前小时，还需要禁用当前时间之前的整点和半点
            if (selectedHour === currentHour) {
              // 如果当前分钟大于30，禁用0和30
              if (currentMinute > 30) {
                minutes.push(0, 30)
              }
              // 如果当前分钟大于0但小于等于30，只禁用0
              else if (currentMinute > 0) {
                minutes.push(0)
              }
              // 如果当前分钟是0，不需要额外禁用
            }
            
            return minutes
          }
        }
      }
      // 如果选择的是未来日期，只限制只能选择整点和半点
      return {
        disabledMinutes: () => {
          // 只允许选择整点（0分）和半点（30分）
          const minutes = []
          for (let i = 0; i < 60; i++) {
            if (i !== 0 && i !== 30) {
              minutes.push(i)
            }
          }
          return minutes
        }
      }
    },
    // 判断是否可以考试（当前时间大于预约时间）
    canTakeExam() {
      if (!this.hasAppointment || !this.appointmentForm.date || !this.appointmentForm.time) {
        return false
      }
      
      try {
        const [year, month, day] = this.appointmentForm.date.split('-').map(Number)
        const [hour, minute] = this.appointmentForm.time.split(':').map(Number)
        const appointmentDateTime = new Date(year, month - 1, day, hour, minute, 0, 0)
        const now = new Date()
        
        return now.getTime() >= appointmentDateTime.getTime()
      } catch (error) {
        console.error('判断考试时间失败:', error)
        return false
      }
    },
    // 按钮文本
    buttonText() {
      if (!this.hasAppointment) {
        return '预约'
      }
      return this.canTakeExam ? '去考试' : '取消预约'
    }
  },
  async mounted() {
    // 先加载岗位列表，再获取预约信息，确保岗位选项已加载
    await this.fetchPositionList()
    await this.fetchApplyInfo()
    // 启动考试时间检查定时器
    this.startExamTimeCheck()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.examTimeCheckTimer) {
      clearInterval(this.examTimeCheckTimer)
      this.examTimeCheckTimer = null
    }
  },
  methods: {
    // 从后台获取岗位列表
    async fetchPositionList() {
      try {
        const response = await request({
          url: '/system/data/getAllCategory',
          method: 'get'
        })
        
        // 处理返回的数据，直接使用 label 和 value
        if (response && Array.isArray(response)) {
          this.positionOptions = response.map(item => ({
            label: item.label,
            value: item.value
          }))
        }
      } catch (error) {
        console.error('获取岗位列表失败:', error)
        this.$message.error('获取岗位列表失败，请稍后重试')
      }
    },
    // 处理按钮点击事件
    handleButtonClick() {
      if (!this.hasAppointment) {
        // 没有预约，执行预约操作
        this.handleSubmit()
      } else if (this.canTakeExam) {
        // 可以考试，跳转到考试页面
        this.$router.push('/exam')
      } else {
        // 有预约但还不能考试，执行取消预约
        this.handleCancel()
      }
    },
    // 处理卡片点击事件
    handleCardClick(type) {
      // 只有在有预约的情况下才能点击跳转
      if(this.hasAppointment && type == 2){
        this.$router.push('/exam/mock')
      }else if (this.hasAppointment && this.hasAppointment) {
        this.$router.push(`/dash/${type}`)
      }
    },
    handleDateChange() {
      // 当日期改变时，如果选择的是今天且当前时间已超过，清空时间选择
      const selectedDate = this.appointmentForm.date
      const today = new Date()
      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
      
      if (this.appointmentForm.time) {
        const [hour, minute] = this.appointmentForm.time.split(':').map(Number)
        
        // 如果时间不是整点或半点，自动调整为最接近的整点或半点
        if (minute !== 0 && minute !== 30) {
          let adjustedHour = hour
          let adjustedMinute = minute
          if (minute < 15) {
            adjustedMinute = 0
          } else if (minute < 45) {
            adjustedMinute = 30
          } else {
            adjustedHour = (hour + 1) % 24
            adjustedMinute = 0
          }
          this.appointmentForm.time = `${String(adjustedHour).padStart(2, '0')}:${String(adjustedMinute).padStart(2, '0')}`
        }
        
        // 如果选择的是今天且当前时间已超过，清空时间选择
        if (selectedDate === todayStr) {
          const now = new Date()
          const [finalHour, finalMinute] = this.appointmentForm.time.split(':').map(Number)
          const selectedTime = new Date()
          selectedTime.setHours(finalHour, finalMinute, 0, 0)
          
          if (selectedTime.getTime() <= now.getTime()) {
            this.appointmentForm.time = ''
          }
        }
      }
    },
    // 处理时间选择器变化事件
    handleTimeChange(value) {
      if (!value) {
        return
      }
      
      // 强制将时间调整为整点或半点
      const [hour, minute] = value.split(':').map(Number)
      if (minute !== 0 && minute !== 30) {
        let adjustedHour = hour
        let adjustedMinute = minute
        // 如果分钟小于15，调整为整点（0分）
        // 如果分钟在15-45之间，调整为半点（30分）
        // 如果分钟大于45，调整为下一个整点（小时+1，0分）
        if (minute < 15) {
          adjustedMinute = 0
        } else if (minute < 45) {
          adjustedMinute = 30
        } else {
          adjustedHour = (hour + 1) % 24
          adjustedMinute = 0
        }
        // 更新表单中的时间
        this.$nextTick(() => {
          this.appointmentForm.time = `${String(adjustedHour).padStart(2, '0')}:${String(adjustedMinute).padStart(2, '0')}`
        })
      }
      
      // 如果选择的是今天，验证时间必须大于当前时间
      const selectedDate = this.appointmentForm.date
      if (selectedDate) {
        const today = new Date()
        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`
        
        if (selectedDate === todayStr) {
          const [finalHour, finalMinute] = this.appointmentForm.time.split(':').map(Number)
          const now = new Date()
          const selectedTime = new Date()
          selectedTime.setHours(finalHour, finalMinute, 0, 0)
          
          if (selectedTime.getTime() <= now.getTime()) {
            this.$message.warning('请选择大于当前时间的日期和时间')
            this.appointmentForm.time = ''
          }
        }
      }
    },
    async fetchApplyInfo() {
      try {
        const data = await getApply()
        // 如果成功获取到数据，绑定到表单
        if (data) {
          this.hasAppointment = true
          // 确保 category 的类型与 positionOptions 中的 value 类型匹配（都是字符串）
          this.appointmentForm.position = String(data.category)
          // 转换日期格式：[2026, 1, 26] -> "2026-01-26"
          if (data.applyDate && Array.isArray(data.applyDate) && data.applyDate.length === 3) {
            const [year, month, day] = data.applyDate
            this.appointmentForm.date = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
          }
          // 转换时间格式：[23, 16] -> "23:16"
          if (data.applyTime && Array.isArray(data.applyTime) && data.applyTime.length === 2) {
            const [hour, minute] = data.applyTime
            this.appointmentForm.time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
          }
          // 预约信息加载完成后，立即检查一次考试时间
          this.$nextTick(() => {
            this.checkExamTime()
          })
        }
      } catch (error) {
        // code=500 或其他错误时，说明没有预约信息，不处理
        this.hasAppointment = false
        console.log('未获取到预约信息')
      }
    },
    async handleCancel() {
      try {
        await this.$confirm('确定要取消预约吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (error) {
        // 用户点击取消，不执行任何操作
        return
      }

      this.submitting = true
      try {
        await cancelApply()
        this.$message.success('取消预约成功！')
        // 只重置状态，不清空表单数据
        this.hasAppointment = false
      } catch (error) {
        // 错误信息已在 request.js 的拦截器中处理
        console.error('取消预约失败:', error)
      } finally {
        this.submitting = false
      }
    },
    async handleSubmit() {
      if (!this.appointmentForm.position) {
        this.$message.warning('请选择岗位')
        return
      }
      if (!this.appointmentForm.date) {
        this.$message.warning('请选择日期')
        return
      }
      if (!this.appointmentForm.time) {
        this.$message.warning('请选择时间')
        return
      }

      // 强制将时间调整为整点或半点
      let [hour, minute] = this.appointmentForm.time.split(':').map(Number)
      // 如果分钟不是0或30，调整为最接近的整点或半点
      if (minute !== 0 && minute !== 30) {
        // 如果分钟小于15，调整为整点（0分）
        // 如果分钟在15-45之间，调整为半点（30分）
        // 如果分钟大于45，调整为下一个整点（小时+1，0分）
        if (minute < 15) {
          minute = 0
        } else if (minute < 45) {
          minute = 30
        } else {
          hour = (hour + 1) % 24
          minute = 0
        }
        // 更新表单中的时间
        this.appointmentForm.time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
      }

      // 确保时间格式正确（整点或半点）
      const finalTime = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`

      // 验证选择的日期和时间是否大于当前时间
      const [year, month, day] = this.appointmentForm.date.split('-').map(Number)
      const selectedDateTime = new Date(year, month - 1, day, hour, minute, 0, 0)
      const now = new Date()
      // 计算允许预约的最小日期：明天（只限制日期）
      const minDate = new Date()
      minDate.setHours(0, 0, 0, 0)
      minDate.setDate(minDate.getDate() + 1)

      if (selectedDateTime.getTime() < minDate.getTime()) {
        this.$message.warning('预约日期必须是明天及之后')
        return
      }

      if (selectedDateTime.getTime() <= now.getTime()) {
        this.$message.warning('请选择大于当前时间的日期和时间')
        return
      }

      // 二次确认
      try {
        await this.$confirm('确定要预约吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (error) {
        // 用户点击取消，不执行任何操作
        return
      }

      this.submitting = true
      try {
        const params = {
          category: this.appointmentForm.position,
          applyDate: this.appointmentForm.date,
          applyTime: finalTime  // 使用调整后的时间，确保是整点或半点
        }
        await applyExam(params)
        this.$message.success('预约成功！')
        // 预约成功后，设置表单为只读状态
        this.hasAppointment = true
        // 这里可以添加跳转逻辑
        // this.$router.push('/some-page')
      } catch (error) {
        // 错误信息已在 request.js 的拦截器中处理
        console.error('预约失败:', error)
      } finally {
        this.submitting = false
      }
    },
    // 启动考试时间检查定时器
    startExamTimeCheck() {
      // 清除已存在的定时器
      if (this.examTimeCheckTimer) {
        clearInterval(this.examTimeCheckTimer)
      }
      
      // 每秒检查一次
      this.examTimeCheckTimer = setInterval(() => {
        this.checkExamTime()
      }, 1000)
      
      // 立即检查一次
      this.checkExamTime()
    },
    // 检查考试时间
    checkExamTime() {
      // 如果没有预约，不检查
      if (!this.hasAppointment || !this.appointmentForm.date || !this.appointmentForm.time) {
        return
      }
      
      // 如果弹窗已经显示，不再重复检查
      if (this.examTimeDialogVisible) {
        return
      }
      
      try {
        const [year, month, day] = this.appointmentForm.date.split('-').map(Number)
        const [hour, minute] = this.appointmentForm.time.split(':').map(Number)
        const appointmentDateTime = new Date(year, month - 1, day, hour, minute, 0, 0)
        const now = new Date()
        
        // 如果当前时间大于等于预约时间，显示弹窗
        if (now.getTime() >= appointmentDateTime.getTime()) {
          this.examTimeDialogVisible = true
        }
      } catch (error) {
        console.error('检查考试时间失败:', error)
      }
    },
    // 处理开始考试
    handleStartExam() {
      // 跳转到考试页面
      this.$router.push('/exam')
    }
  }
}
</script>

<style scoped lang="scss" src="./assets/index.scss" />